export default {
  methods: {
    errorHandler (error) {
      if (error && error.response) {
        if (error.response.status === 401) {
          if (!error.response.config.url.includes('auth')) {
            this.failNotification('La sesión ha vencido')
            localStorage.clear()
            this.$router.push({ name: 'Login' })
          }
        } else if (error.response.status === 404) {
          this.failNotification('Error 404')
        } else if (error.response.status === 403) {
          this.failNotification('Permisos insuficientes - Error 403')
        } else if (error.response.status === 500) {
          this.failNotification()
        }
      } else {
        this.failNotification('Servicio no disponible')
      }
    }
  }
}
